import React from 'react';

import { validateAcceptInvite } from "Data/users/UserValidations";

import Form from "Components/Form";
import Logo from "Components/Logo";
import Button from "UI/Button";
import TextField from "UI/Form/TextField";

export default function InviteCard({onSubmit}) {
    return <div className="w-full max-w-xs">
        <Logo className="h-12 text-white mb-4 m-auto" />
        <div className="bg-white shadow-md rounded px-8 pt-10 pb-8 mb-4 space-y-4">
            <div className='prose'>
                <h1 className='text-gray-900'>Hey, nice to meet you!</h1>
                <p>A member of your team sent you an invite to create stories on Patchwork.</p>
                <p>To join, finish creating an account below.</p>
            </div>
            <Form id='accept-invite' validate={validateAcceptInvite} onSubmit={onSubmit} className='pt-6'>
                {(data, onChange, validation) =>
                    <fieldset className='flex-1 space-y-4'>
                        <TextField
                            id='fullname'
                            label='Full name'
                            value={data.fullname}
                            onChange={onChange('fullname')}
                            error={validation.hasErrors('fullname')}
                            help={validation.getErrors('fullname')}
                        />
                        <TextField
                            id='password'
                            label='Password'
                            type='password'
                            value={data.password}
                            onChange={onChange('password')}
                            error={validation.hasErrors('password')}
                            help={validation.getErrors('password')}
                        />
                        <div className='flex flex-row-reverse'>
                            <Button type='primary'>Accept</Button>
                        </div>
                    </fieldset>
                }
            </Form>
        </div>
    </div>
}
